/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VIEW = "FORGOT_PASSWORD" | "SIGN_IN" | "SIGN_UP" | "%future added value";
export type AuthPopup_local = {
    readonly authPopup: {
        readonly open: boolean;
        readonly focus: boolean;
        readonly view: VIEW | null;
    };
    readonly " $refType": "AuthPopup_local";
};
export type AuthPopup_local$data = AuthPopup_local;
export type AuthPopup_local$key = {
    readonly " $data"?: AuthPopup_local$data;
    readonly " $fragmentRefs": FragmentRefs<"AuthPopup_local">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthPopup_local",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthPopup",
                    "kind": "LinkedField",
                    "name": "authPopup",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "open",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "focus",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "view",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '232d3b62fb4d3e7408ba5400c9cc7431';
export default node;
